import { Controller } from "@hotwired/stimulus"

// Makes each marked value in a task's description (compare blocks, paired
// table cells, before -> after pairs) open the task's document with that value
// found and marked (pdf-find controller in the attachment modal).
export default class extends Controller {
  static values = { url: String }
  static VALUE_SELECTOR = ".vc-line, td.vc-paired, .vc-inline"

  connect() {
    this.element.querySelectorAll(this.constructor.VALUE_SELECTOR).forEach((node) => {
      node.dataset.locatable = "true"
      node.tabIndex = 0
      node.title = "Find on the document"
    })
    this.onClick = (event) => this.open(event)
    this.onKey = (event) => { if (event.key === "Enter") this.open(event) }
    this.element.addEventListener("click", this.onClick)
    this.element.addEventListener("keydown", this.onKey)
  }

  disconnect() {
    this.element.removeEventListener("click", this.onClick)
    this.element.removeEventListener("keydown", this.onKey)
  }

  open(event) {
    const node = event.target.closest("[data-locatable]")
    if (!node || !this.element.contains(node) || event.target.closest("a, button")) return
    const value = this.valueOf(node)
    if (!value) return
    event.preventDefault()
    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("find", value)
    const link = document.createElement("a")
    link.href = url.pathname + url.search
    link.dataset.turboFrame = "modal"
    link.hidden = true
    this.element.appendChild(link)
    link.click()
    link.remove()
  }

  // The value as written: without the holes, deltas, and ditto marks drawn
  // around it.
  valueOf(node) {
    const copy = node.cloneNode(true)
    copy.querySelectorAll(".vc-gap, .vc-delta, .vc-ditto, .sr-only").forEach((extra) => extra.remove())
    return copy.textContent.replace(/ /g, "").trim()
  }
}
